import React from 'react';

import { flagStyles } from '../settings';

const SvgCL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1056px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCL;
